<template>
  <div v-if="showFormGroup" class="sui-form-group" :class="[formGroupSize ? 'sui-form-group--' + formGroupSize : '']">
    <div class="sui-form-group__title" v-if="title">{{ _locale(title) }}</div>
    <div class="sui-form-group__content">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SuiFormGroup',
  inject: {
    SuiForm: {
      default: null
    },
    elForm: {
      default: null
    }
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      validator: function (value) {
        return ['medium', 'small', 'mini'].indexOf(value) !== -1
      }
    },
    items: {
      type: Array,
      default: () => []
    },
    visible: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    _formSize() {
      if (this.$options.propsData.size === undefined && this.SuiForm && this.SuiForm.size) {
        return this.SuiForm.size
      } else if (this.elForm && this.elForm.size) {
        return this.elForm.size
      } else {
        return (this.$ELEMENT || {}).size
      }
    },
    formGroupSize() {
      if (this._formSize) {
        return this._formSize
      }
      return this.size
    },
    showFormGroup() {
      return this.visible
    }
  }
}
</script>
<style lang="scss" scoped>
@import 'element-ui/packages/theme-chalk/src/common/var.scss';
@import '../../../../styles/element-variables.scss';

.sui-form-group {
  display: flex;
  &__title {
    flex-shrink: 0;
    color: #687583;
    font-size: $--form-label-font-size;
    padding-right: 20px;
    line-height: 40px;
  }

  &--small {
    .sui-form-group__title {
      line-height: 32px;
    }
  }

  &--medium {
    .sui-form-group__title {
      line-height: 36px;
    }
  }

  &--mini {
    .sui-form-group__title {
      line-height: 28px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SimbartUI/components/data/SuiFormGroup.vue